var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item pl-4"},[_c('a',{staticClass:"nav-link",attrs:{"href":_vm.dimensionsByPagesSpaLink}},[_vm._v("\n    "+_vm._s(_vm.$t("segmentationByPages"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }